export default function ($sce) {
    return function(val) {
        return $sce.trustAsHtml(val);
    };
};



/** WEBPACK FOOTER **
 ** ./js/filters/raw.js
 **/